import React, { useEffect, useState, useRef} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import ChangeTabContext from '../comps/CreateContext';
import vm from '../../static/js/unit';
import scheme from '../../static/js/scheme';
import Base from '../../base';
import Main from './main';
import Empty from './empty';
import 'swiper/swiper.scss';
import './index.scss';

SwiperCore.use([Pagination]);
const Home = ({params}) => {

  const ids = params.seriesId.split('-');
  const [navList, setNavList] = useState([]);
  const [brandName, setBrandName] = useState('');
  const [current, setCurrent] = useState(0);
  const [tabFix, setTabFix] = useState(Base.isApp ? true : false);
  const [allow, setAllow] = useState(false);
  const [series, setSeries] = useState({[ids[1]]:{ 0: {list: [], page: '', more: false,} }});
  const [tabOption, setOption] = useState({
    id: ids[1],
    tab: 0,
  });
  const tabRef = useRef();
  const handleScroll = () => {
    // setScrolling(true);
    const more = series[tabOption.id] && series[tabOption.id][tabOption.tab] ? series[tabOption.id][tabOption.tab].more : false;
    Base.baseScroll(setData, more, setTabFix);
  }

  useEffect(() => {
    vm.ajax({
      url: process.env.REACT_APP_CHENGDU + 'getSeriesListByBrand',
      data: {
        showid: process.env.REACT_APP_CHEZHAN_ID,
        brandid: ids[0],
      },
      success(res) {
        let i = 0;
        const arr = [];
        res.result.forEach(item => {
          item.list.forEach(m => {
            if (m.seriesid === parseInt(ids[1])) setCurrent(i);
            arr.push({id: m.seriesid, name: m.seriesname});
            i += 1;
          });
        });
        setNavList(arr);
      },
    });
    document.body.style.overflow = 'auto';
  }, []);

  useEffect(() => {
    if (scheme.version) {
      const source = vm.getUrlParams('source') === 'series';
      const btns = source ? [] : [{
        title: '车展专题',
        titlecolor: '#ffffff',
        scheme: scheme.insidebrowser('https://mfang.autohome.com.cn/preview/544'),
      }];
      window.AHAPP.invokeNative('actionbarinfo', {
        title: brandName,
        addmenulist: btns,
        stablemenulist: ['share'],
        success: Base.appSetting,
      });
    }
    document.title = brandName;
  }, [brandName]);

  useEffect(() => {
    setData(true);
  }, [tabOption]);
  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, false);
    return () => {
      window.removeEventListener('scroll', handleScroll, false)
    }
  }, [tabOption, series]);

  let loading = false;
  let firstLoad = true;
  setTimeout(() => {
    firstLoad = false;
  }, 200);
  const option = [{
    cms_tag_ids: '100',
    video_tag_ids: '353',
    chejiahao_tag_ids: '154',
    club_begin_time: '2021-08-01 00:00:00',
    club_end_time: '2021-08-28 23:59:59',
  },
  {
    cms_tag_ids: '92,93,95,96',
    video_tag_ids: '354',
    chejiahao_tag_ids: '1',
    club_begin_time: '2021-08-29 00:00:00',
    club_end_time: '2021-09-08 00:00:00',
  }];
  const setData = (bool) => {
    const {id, tab} = tabOption;
    const live = series[id] && series[id][tab] && series[id][tab].page;
    const page = live ? series[id][tab].page : '';
    if (loading || id === 0 || (bool && live)) {
      return;
    }
    loading = true;
    vm.ajax({
      url: 'https://autoapi.autohome.com.cn/zxtd/kyyxcx/data_cms_autoshow_opu_feed_openbox',
      data: {
        autoshowid: process.env.REACT_APP_CHEZHAN_ID,
        series_id: id,
        pagesize: 10,
        pageid: page,
        datatype: 1,
        _appid: 'm',
        ...option[tab],
      },
      success: data => {
        loading = false;
        if (data.result && data.result.list && data.result.list.length > 0) {
          setSeries((obj) => {
            const newList = obj[id] && obj[id][tab] ? [...obj[id][tab].list, ...data.result.list] : data.result.list;
            return {
              ...obj,
              [id]: {
                ...obj[id],
                [tab]: {
                  list: newList,
                  more: data.result.haveMore,
                  page: data.result.pageid,
                },
              }
            }
          });
        }
      },
    });
  }
  const handleSwiper = (s) => {
    let timer = 0;
    if (firstLoad) {
      timer = 200;
      firstLoad = false;
    } else {
      setOption({
        id: navList[s.realIndex].id,
        tab: 0,
      });
    }
    setTimeout(() => {
      const active = document.getElementsByClassName('swiper-pagination-bullet-active')[0];
      if (!active) return;
      const to = active.offsetLeft - (Base.winWidth - active.offsetWidth) / 2
      tabRef.current.scrollLeft = to;
    }, timer);
  };
  
  return (
    navList.length > 0 && 
    <ChangeTabContext.Provider value={{
      mainId: ids[1],
      brandName,
      setBrandName,
      tabOption,
    }}>
      <div className={'nav__content' + (tabFix ? ' fix' : '')}>
        <div className="nav__scroll" ref={tabRef}></div>
      </div>
      <Swiper className="mySwiper"
        autoHeight={true}
        loop={false}
        allowTouchMove={true}
        initialSlide={current}
        onSlideChangeTransitionEnd={(s) => handleSwiper(s)}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return `<div class="${className}"><span>${navList[index].name}</span></div>`;
          },
          el: '.nav__scroll',
        }}
      >
        {
          navList.map(item => {
            return <SwiperSlide key={item.id}>
              {({ isActive }) => (
                isActive || series[item.id] ? 
                <Main setOption={setOption} data={series[item.id]} sID={item.id} />
                : <Empty />
              )}
            </SwiperSlide>
          })
        }
      </Swiper>
    </ChangeTabContext.Provider>
  )
}

export default Home;